<div class="row mt-5 mb-4" *ngIf="showAdditionalMemberSavings">
  <div class="col-12 col-lg-12">
    <app-card-container>
      <div class="row mb-3">
        <div class="col-12">
          <div class="header-text">Additional Member Savings</div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-lg-12 sub-text2" *ngIf="getAdditionalMemberCostText()">{{ getAdditionalMemberCostText() }}</div>
        <div class="col-12 col-lg-12 sub-text2" *ngIf="getMemberLimitText()">{{ getMemberLimitText() }}</div>
        <div class="col-12 col-lg-12 mt-3 sub-text2">{{ MEMBER_DEFINITION_STATEMENT }}</div>
      </div>
    </app-card-container>
  </div>
</div>
